import { useState } from 'react'
import {
    Badge,
    Dropdown,
    NavItem,
    NavLink,
    OverlayTrigger,
    Tooltip,
} from 'react-bootstrap'
import { useAuth } from '../../../../auth'
import { useAppSelector } from '../../../../store/hooks'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleInfo, faList, faUser } from '@fortawesome/free-solid-svg-icons'
import { hasAccess } from '../../../auth/utils/Auth'
import { ROLES } from '../../../../routeConfig'
import { Link } from 'react-router-dom'
import Common from '../../../common/Common'
import { FEATURES } from '../../../../config/features'

const UserMenuItem = () => {
    const [dropdownOpen, setDropdownOpen] = useState(false)
    const { roles: userRoles } = useAppSelector(
        (state: any) => state.security.user
    )

    const { user } = useAuth()
    return (
        <Dropdown as={NavItem} show={dropdownOpen} onToggle={setDropdownOpen}>
            <OverlayTrigger
                placement="bottom"
                trigger={['hover', 'focus']}
                show={!dropdownOpen ? undefined : false}
                overlay={
                    <Tooltip id="tooltip-bottom" style={{ margin: 0 }}>
                        My account
                    </Tooltip>
                }
            >
                {({ ref, ...triggerHandler }) => (
                    <Dropdown.Toggle as={NavLink} ref={ref} {...triggerHandler}>
                        <span className="me-2 d-none d-lg-inline small">
                            {user?.username}
                        </span>
                        {user?.image_id ? (
                            <img
                                src={user.image}
                                className="rounded-circle"
                                alt={user.username}
                                style={{
                                    maxWidth: 32,
                                    maxHeight: 32,
                                }}
                            />
                        ) : (
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width={24}
                                height={24}
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth={2}
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                className="feather feather-user"
                            >
                                <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                                <circle cx={12} cy={7} r={4} />
                            </svg>
                        )}
                    </Dropdown.Toggle>
                )}
            </OverlayTrigger>
            <Dropdown.Menu
                style={{ margin: 0 }}
                className="dropdown-top-100 dropdown-menu-end shadow animated--grow-in"
            >
                <Dropdown.Item as={Link} to={'/account'}>
                    <FontAwesomeIcon
                        icon={faUser}
                        className="me-2 fa-fw"
                        size="sm"
                    />{' '}
                    My Account
                </Dropdown.Item>
                {FEATURES.activityLog && (
                    <Dropdown.Item as={Link} to={'/account/activity-log'}>
                        <FontAwesomeIcon
                            icon={faList}
                            className="me-2 fa-fw"
                            size="sm"
                        />{' '}
                        Activity Log{' '}
                        <Badge pill bg="warning" className="">
                            <small>Soon</small>
                        </Badge>
                    </Dropdown.Item>
                )}
                <Dropdown.Divider as={'div'} />
                {hasAccess(userRoles, [ROLES.Owner, ROLES.Admin]) && (
                    <Dropdown.Item as={Link} to={'/administration'}>
                        <FontAwesomeIcon
                            icon={faUser}
                            className="me-2 fa-fw"
                            size="sm"
                        />{' '}
                        Administration
                    </Dropdown.Item>
                )}
                <Dropdown.Item as={Link} to="/help">
                    <FontAwesomeIcon
                        icon={faCircleInfo}
                        className="me-2 fa-fw"
                        size="sm"
                    />{' '}
                    Knowledge Base
                </Dropdown.Item>
                <Common.About triggerType="dropdownItem" text="About" />
            </Dropdown.Menu>
        </Dropdown>
    )
}

export default UserMenuItem
